import {FC, useCallback, useEffect, useState} from "react";
import BaseModal from "@memaro/components/Modal.tsx";
import Selector from "./Selector.tsx";
import MobileStepper from "@mui/material/MobileStepper";
import Button from "@mui/material/Button";
import {Plan} from "@memaro/api";
import PaymentOverview from "./PaymentOverview.tsx";
import apiClient from "../../../lib/api.ts";
import {useFeedback} from "@memaro/feedback";

export type ModalProps = {
    open: boolean;
    profileID: string;
    availablePlans: Plan[];
    onClose: () => void;
}

const Modal: FC<ModalProps> = ({open, profileID, onClose, availablePlans}) => {
    const [selectedPlan, setSelectedPlan] = useState<Plan | undefined>(undefined);
    const [yearsUpfront, setYearsUpfront] = useState<number>(10)
    const [activeStep, setActiveStep] = useState<number>(0)
    const [loading, setLoading] = useState<boolean>(false);
    const handleNext = useCallback(() => setActiveStep(prev => prev + 1), [])
    const handlePrev = useCallback(() => setActiveStep(prev => prev - 1), [])
    const {error} = useFeedback();

    useEffect(() => {
        if (!open) {
            setSelectedPlan(undefined)
            setYearsUpfront(10)
            setActiveStep(0)
        }
    }, [open])

    const handleInitiatePayment = useCallback(() => {
        setLoading(true)
        apiClient.initiatePayment(profileID, {plan: selectedPlan!, yearsUpfront: yearsUpfront})
            .then((output) => window.location.href = output.url)
            .catch(() => error?.("Er is een fout opgetreden bij het initiëren van de betaling"))
            .finally(() => setLoading(false))
    }, [error, profileID, selectedPlan, yearsUpfront]);

    return (
        <BaseModal
            open={open}
            onClose={onClose}
            title="Selecteer het gewenste pakket"
            fullScreenOnMobile
            actions={[
                <MobileStepper
                    variant="dots"
                    steps={2}
                    position="static"
                    activeStep={activeStep}
                    sx={{flexGrow: 1}}
                    nextButton={
                        activeStep == 0 ? (
                            <Button size="small" onClick={handleNext} disabled={!selectedPlan}>
                                Volgende
                            </Button>
                        ) : activeStep == 1 ? (
                            <Button size="small" onClick={handleInitiatePayment} loading={loading}>
                                Betalen
                            </Button>
                        ) : null
                    }
                    backButton={
                        <Button size="small" disabled={activeStep === 0} onClick={handlePrev}>
                            Terug
                        </Button>
                    }
                />

            ]}
        >
            {activeStep == 0 ? (
                <Selector
                    availablePlans={availablePlans}
                    selected={selectedPlan}
                    onSelect={setSelectedPlan}
                />
            ) : activeStep == 1 && selectedPlan ? (
                <PaymentOverview
                    selectedPlan={selectedPlan}
                    yearsUpfront={yearsUpfront}
                    onChangeYearsUpfront={setYearsUpfront}
                />
            ) : null}
        </BaseModal>
    )
}

export default Modal
